import api from './api';

export interface ParcelaDesembolso {
  id: string;
  planoTrabalhoId: string;
  mes: string; // YYYY-MM
  valor: number;
  dataCriacao?: string;
  dataAtualizacao?: string;
}

const parcelaDesembolsoService = {
  listByPlano: async (planoId: string): Promise<ParcelaDesembolso[]> => {
    const res = await api.get(`/parcela-desembolso/plano/${planoId}`);
    return res.data;
  },

  create: async (payload: Omit<ParcelaDesembolso, 'id' | 'dataCriacao' | 'dataAtualizacao'>): Promise<ParcelaDesembolso> => {
    const res = await api.post('/parcela-desembolso', payload);
    return res.data;
  },

  update: async (id: string, payload: Partial<ParcelaDesembolso>): Promise<ParcelaDesembolso> => {
    const res = await api.put(`/parcela-desembolso/${id}`, payload);
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/parcela-desembolso/${id}`);
  },
};

export default parcelaDesembolsoService;